module.exports = __webpack_public_path__ + "media/images/athletes/2020-4291ea6deb18797e727f8a219a9773ca.png";